import React from 'react'
import './career-apply.scss'
import { Fade } from 'react-reveal'
import Image from '../../../assets/img/Project-Images/img2.jpeg'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import useFetch from '../../../Hooks/useFetch'

export default function CareerApply() {
  const { data } = useFetch()
  const myField = data?.items.find((item, index) => {
    if (item.sys.id === '2QuRoqsOEFf2PBBsItcuS4') {
      return item
    }
  })

  // console.log(myField?.fields)
  // console.log(data?.Careerapply.title)

  return (
    <div id='career-apply'>
      <img src={myField?.fields.caImg.fields.file.url} />
      <Fade left>
        <div className='dark-card'>
          <div>
            <h2>{myField?.fields.caTitle}</h2>

            <p>{myField?.fields.caParagraph}</p>
            <p>{myField?.fields.caParagraph2}</p>
            <a href={myField?.fields.caFlink} className='button'>
              <button>
                <div>
                  <ArrowForwardIosIcon />
                </div>
                <span>Apply here</span>
              </button>
            </a>
          </div>
        </div>
      </Fade>
    </div>
  )
}
